import { Component, inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Subscription } from 'rxjs';
import { OpenSquashService } from '../shared/services/open-squash-service';
import { TournamentCategory } from '../shared/tournament-category';
import { CategoryGroup } from '../shared/category-group';
import { CommonModule } from '@angular/common';
import { CategoryGroupComponent } from "../category-group-component/category-group-component";

@Component({
  selector: 'app-category-component',
  imports: [RouterModule, CommonModule, CategoryGroupComponent],
  templateUrl: './category-component.html',
  styleUrl: './category-component.scss',
})
export class CategoryComponent implements OnDestroy {
  private openSquashService = inject(OpenSquashService);

  categoryType: string | null = null;
  tournamentCategory!: TournamentCategory | undefined;
  currentGroup: CategoryGroup = { name: '', players: [] };
  groups: CategoryGroup[] = [];
  tournamentSubscription!: Subscription;

  constructor() {
    const route = inject(ActivatedRoute);
    route.paramMap.subscribe((params) => {
      this.categoryType = params.get('categoryType');

      this.tournamentSubscription = this.openSquashService.tournament$.subscribe(tournament => {
        this.tournamentCategory = tournament.categories.find(c => c.category === this.categoryType);
        this.groups = this.tournamentCategory?.groups
          ? this.tournamentCategory.groups.sort((a, b) => a.name.localeCompare(b.name))
          : [];
        this.currentGroup = this.groups[0];
        if (!this.groups.some(group => group.name === 'finales')) {
          this.groups.push({ name: 'finales', players: [] });
        }
        if (!this.groups.some(group => group.name === 'posiciones')) {
          this.groups.push({ name: 'posiciones', players: [] });
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.tournamentSubscription.unsubscribe();
  }

  setGroup(group: CategoryGroup) {
    this.currentGroup = group;
  }
}
